/**
 * WEB-28: куда ведёт ярлык установленного приложения.
 *
 * 🔴 Раньше `start_url` в манифесте был прибит к `/j/chat` — участниковской
 * двери. Кто бы ни установил приложение и с какой бы страницы, ярлык открывал
 * чат участника: владелец попадал на «вы ещё не вошли в чат» и упирался в
 * тупик (живая находка владельца 09.09, сразу после выката WEB-25).
 *
 * Теперь ярлык ведёт в корень, а решает эта развилка — по тому единственному
 * признаку, который на устройстве действительно есть: сохранённой сессии
 * участника. Она лежит локально и читается синхронно, без похода в сеть, —
 * значит экран не мигает «войдите» перед тем, как увести в переписку.
 *
 * Владельца сюда не заводим: у него сессия кабинета живёт в куках и проверяется
 * запросом `/me`, ждать который на старте значит показать пустоту. Ему и так
 * сюда: `<Auth/>` пустит его дальше.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import Auth from '../../pages/Auth/auth';
import { loadMemberSession } from '../../msg/memberSession';
import { CABINET_QUERY, MEMBER_CHAT_PATH } from '../../msg/inviteLink';

/**
 * 🔴 Ключ от кабинета (ревью 09.09). Без него развилка запирала владельца:
 * в браузере, где есть сессия участника, корень ВСЕГДА уводил в переписку, и
 * форма входа становилась недостижимой — а `PrivateRoutes` после выхода или
 * протухшей авторизации отправляет именно на корень. Петли не возникало, но и
 * войти было нельзя. Признак явный и в адресе, чтобы ссылка работала откуда
 * угодно: из чата участника, из закладки, из письма.
 */
function wantsCabinet(search) {
  try {
    return new URLSearchParams(search || '').has(CABINET_QUERY);
  } catch {
    return false;
  }
}

const StartRoute = () => {
  // Читаем ОДИН раз на монтирование: сессия может смениться только уходом с
  // этой страницы, а перечитывание на каждый рендер дало бы прыжок под руками.
  const [member] = React.useState(() => {
    try {
      return loadMemberSession();
    } catch {
      // 🔴 Отказ хранилища — это «не знаем», а не «участника нет». Но увести
      // в чат без сессии некуда, поэтому показываем вход: там есть путь и для
      // участника (перенос с другого устройства), а тупика нет.
      return null;
    }
  });

  // Явная просьба сильнее догадки: человек сказал, куда ему надо.
  if (member && !wantsCabinet(window.location.search)) {
    return <Navigate to={MEMBER_CHAT_PATH} replace />;
  }
  return <Auth />;
};

export default StartRoute;
